import React from 'react';
import { Footer } from '../components';
import { Github, Linkedin } from '@styled-icons/bootstrap';
import 'styled-components/macro';

export function FooterContainer() {
  return (
    <Footer>
      <Footer.Text>
        &#169; 2023 Coded by Nadeesha Nawagaththegama
        {/* <Footer.Link href="https://dribbble.com/Giulio_Cuscito">
          Giulio Cuscito
        </Footer.Link> */}
        <Footer.Span>.</Footer.Span>
      </Footer.Text>
      <Footer.Wrapper>
        <Footer.Link
          href="https://www.linkedin.com/in/nadeeshadileen"
          aria-label="GitHub repo"
          css="margin-right: 0.7em;"
        >
          <Github size="24" css="vertical-align:text-bottom" />
        </Footer.Link>
        <Footer.Link
          href="https://www.linkedin.com/in/nadeeshadileen"
          aria-label="LinkedIn"
        >
          <Linkedin size="24" css="vertical-align:text-bottom" />
        </Footer.Link>
      </Footer.Wrapper>
    </Footer>
  );
}
